import type { PageAdType } from '@/modules/adv/types'

export const EXISTING_AD_FREE_BANNERS: Partial<Record<PageAdType, boolean>> = {
    sidebar: true,
    leaderboard: true,
    leaderboard_rest: true,
}
